import { Pipe, PipeTransform } from '@angular/core';
import { AttributeBase, LegAttribute } from '@approot/models';

@Pipe({
  name: 'activeAttributes'
})
export class ActiveAttributesPipe implements PipeTransform {
  transform(
    activeAttributes: LegAttribute[],
    attributesAsFormControls: AttributeBase<any>[]
  ): AttributeBase<any>[] {
    return activeAttributes.map(activeAttribute => {
      const attribute = attributesAsFormControls.find(
        att => att.key === activeAttribute.shortName
      );
      return attribute;
    });
  }
}
